import 'angular:locale/data:en';
import './projects/website/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
